import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _class2, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35;
import { tracked } from "@glimmer/tracking";
import { getOwner, setOwner } from "@ember/application";
import { A } from "@ember/array";
import EmberObject, { computed, get, getProperties } from "@ember/object";
import { dependentKeyCompat } from "@ember/object/compat";
import { alias, equal, filterBy, gt, mapBy, or } from "@ember/object/computed";
import Evented from "@ember/object/evented";
import { cancel } from "@ember/runloop";
import { service } from "@ember/service";
import { camelize } from "@ember/string";
import { htmlSafe } from "@ember/template";
import { isEmpty } from "@ember/utils";
import { Promise } from "rsvp";
import { ajax } from "discourse/lib/ajax";
import { url } from "discourse/lib/computed";
import cookie, { removeCookie } from "discourse/lib/cookie";
import { longDate } from "discourse/lib/formatter";
import { NotificationLevels } from "discourse/lib/notification-levels";
import PreloadStore from "discourse/lib/preload-store";
import { emojiUnescape } from "discourse/lib/text";
import { userPath } from "discourse/lib/url";
import { defaultHomepage, escapeExpression } from "discourse/lib/utilities";
import Singleton from "discourse/mixins/singleton";
import Badge from "discourse/models/badge";
import Bookmark from "discourse/models/bookmark";
import Category from "discourse/models/category";
import Group from "discourse/models/group";
import RestModel from "discourse/models/rest";
import Site from "discourse/models/site";
import UserAction from "discourse/models/user-action";
import UserActionStat from "discourse/models/user-action-stat";
import UserBadge from "discourse/models/user-badge";
import UserDraftsStream from "discourse/models/user-drafts-stream";
import UserPostsStream from "discourse/models/user-posts-stream";
import UserStream from "discourse/models/user-stream";
import { isTesting } from "discourse-common/config/environment";
import deprecated from "discourse-common/lib/deprecated";
import { getOwnerWithFallback } from "discourse-common/lib/get-owner";
import getURL, { getURLWithCDN } from "discourse-common/lib/get-url";
import discourseLater from "discourse-common/lib/later";
import discourseComputed from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
export const SECOND_FACTOR_METHODS = {
  TOTP: 1,
  BACKUP_CODE: 2,
  SECURITY_KEY: 3
};
export const MAX_SECOND_FACTOR_NAME_LENGTH = 300;
const TEXT_SIZE_COOKIE_NAME = "text_size";
const COOKIE_EXPIRY_DAYS = 365;
export function extendTextSizeCookie() {
  const currentValue = cookie(TEXT_SIZE_COOKIE_NAME);
  if (currentValue) {
    cookie(TEXT_SIZE_COOKIE_NAME, currentValue, {
      path: "/",
      expires: COOKIE_EXPIRY_DAYS
    });
  }
}
const isForever = dt => moment().diff(dt, "years") < -100;
let userFields = ["bio_raw", "website", "location", "name", "title", "locale", "custom_fields", "user_fields", "muted_usernames", "ignored_usernames", "allowed_pm_usernames", "profile_background_upload_url", "card_background_upload_url", "muted_tags", "tracked_tags", "watched_tags", "watching_first_post_tags", "date_of_birth", "primary_group_id", "flair_group_id", "user_notification_schedule", "sidebar_category_ids", "sidebar_tag_names", "status"];
export function addSaveableUserField(fieldName) {
  userFields.push(fieldName);
}
let userOptionFields = ["mailing_list_mode", "mailing_list_mode_frequency", "external_links_in_new_tab", "email_digests", "email_in_reply_to", "email_messages_level", "email_level", "email_previous_replies", "color_scheme_id", "dark_scheme_id", "dynamic_favicon", "enable_quoting", "enable_defer", "automatically_unpin_topics", "digest_after_minutes", "new_topic_duration_minutes", "auto_track_topics_after_msecs", "notification_level_when_replying", "like_notification_frequency", "include_tl0_in_digests", "theme_ids", "allow_private_messages", "enable_allowed_pm_users", "homepage_id", "hide_profile_and_presence", "text_size", "title_count_mode", "timezone", "skip_new_user_tips", "seen_popups", "default_calendar", "bookmark_auto_delete_preference", "sidebar_link_to_filtered_list", "sidebar_show_count_of_new_items", "watched_precedence_over_muted", "topics_unread_when_closed"];
export function addSaveableUserOptionField(fieldName) {
  userOptionFields.push(fieldName);
}
function userOption(userOptionKey) {
  return computed(`user_option.${userOptionKey}`, {
    get(key) {
      deprecated(`Getting ${key} property of user object is deprecated. Use user_option object instead`, {
        id: "discourse.user.userOptions",
        since: "2.9.0.beta12",
        dropFrom: "3.0.0.beta1"
      });
      return this.get(`user_option.${key}`);
    },
    set(key, value) {
      deprecated(`Setting ${key} property of user object is deprecated. Use user_option object instead`, {
        id: "discourse.user.userOptions",
        since: "2.9.0.beta12",
        dropFrom: "3.0.0.beta1"
      });
      if (!this.user_option) {
        this.set("user_option", {});
      }
      return this.set(`user_option.${key}`, value);
    }
  });
}
let User = (_dec = userOption("mailing_list_mode"), _dec2 = userOption("external_links_in_new_tab"), _dec3 = userOption("enable_quoting"), _dec4 = userOption("dynamic_favicon"), _dec5 = userOption("automatically_unpin_topics"), _dec6 = userOption("likes_notifications_disabled"), _dec7 = userOption("hide_profile_and_presence"), _dec8 = userOption("title_count_mode"), _dec9 = userOption("enable_defer"), _dec10 = userOption("timezone"), _dec11 = userOption("skip_new_user_tips"), _dec12 = userOption("default_calendar"), _dec13 = userOption("bookmark_auto_delete_preference"), _dec14 = userOption("seen_popups"), _dec15 = userOption("should_be_redirected_to_top"), _dec16 = userOption("redirected_to_top"), _dec17 = userOption("treat_as_new_topic_start_date"), _dec18 = gt("private_messages_stats.all", 0), _dec19 = gt("private_messages_stats.mine", 0), _dec20 = gt("private_messages_stats.unread", 0), _dec21 = url("id", "username_lower", "/admin/users/%@1/%@2"), _dec22 = equal("trust_level", 0), _dec23 = equal("trust_level", 3), _dec24 = equal("trust_level", 4), _dec25 = or("staff", "isLeader"), _dec26 = alias("sidebar_category_ids"), _dec27 = alias("sidebar_sections"), _dec28 = mapBy("sidebarTags", "name"), _dec29 = filterBy("groups", "has_messages", true), _dec30 = alias("can_pick_theme_with_custom_homepage"), _dec31 = discourseComputed("can_be_deleted", "post_count"), _dec32 = discourseComputed(), _dec33 = discourseComputed(), _dec34 = discourseComputed(), _dec35 = discourseComputed(), _dec36 = computed("admin", "moderator"), _dec37 = discourseComputed("username_lower"), _dec38 = discourseComputed("username", "name"), _dec39 = discourseComputed("profile_background_upload_url"), _dec40 = discourseComputed(), _dec41 = discourseComputed(), _dec42 = discourseComputed(), _dec43 = discourseComputed(), _dec44 = discourseComputed(), _dec45 = discourseComputed("username"), _dec46 = discourseComputed("trust_level"), _dec47 = discourseComputed("previous_visit_at"), _dec48 = discourseComputed("suspended_till"), _dec49 = discourseComputed("suspended_till"), _dec50 = discourseComputed("silenced_till"), _dec51 = discourseComputed("suspended_till"), _dec52 = discourseComputed("silenced_till"), _dec53 = discourseComputed("sidebar_tags.[]"), _dec54 = discourseComputed("groups.[]"), _dec55 = discourseComputed("filteredGroups", "numGroupsToDisplay"), _dec56 = discourseComputed("statsExcludingPms.@each.count"), _dec57 = discourseComputed("stats.@each.isPM"), _dec58 = discourseComputed("can_delete_account"), _dec59 = discourseComputed("groups.@each.title", "badges.[]"), _dec60 = discourseComputed("groups.[]"), _dec61 = discourseComputed("user_option.text_size_seq", "user_option.text_size"), _dec62 = discourseComputed("second_factor_enabled", "staff"), _dec63 = discourseComputed("tracked_tags.[]", "watched_tags.[]", "watching_first_post_tags.[]"), (_class2 = class User extends RestModel.extend(Evented) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "appEvents", _descriptor2, this);
    _initializerDefineProperty(this, "userTips", _descriptor3, this);
    _initializerDefineProperty(this, "do_not_disturb_until", _descriptor4, this);
    _initializerDefineProperty(this, "status", _descriptor5, this);
    _initializerDefineProperty(this, "mailing_list_mode", _descriptor6, this);
    _initializerDefineProperty(this, "external_links_in_new_tab", _descriptor7, this);
    _initializerDefineProperty(this, "enable_quoting", _descriptor8, this);
    _initializerDefineProperty(this, "dynamic_favicon", _descriptor9, this);
    _initializerDefineProperty(this, "automatically_unpin_topics", _descriptor10, this);
    _initializerDefineProperty(this, "likes_notifications_disabled", _descriptor11, this);
    _initializerDefineProperty(this, "hide_profile_and_presence", _descriptor12, this);
    _initializerDefineProperty(this, "title_count_mode", _descriptor13, this);
    _initializerDefineProperty(this, "enable_defer", _descriptor14, this);
    _initializerDefineProperty(this, "timezone", _descriptor15, this);
    _initializerDefineProperty(this, "skip_new_user_tips", _descriptor16, this);
    _initializerDefineProperty(this, "default_calendar", _descriptor17, this);
    _initializerDefineProperty(this, "bookmark_auto_delete_preference", _descriptor18, this);
    _initializerDefineProperty(this, "seen_popups", _descriptor19, this);
    _initializerDefineProperty(this, "should_be_redirected_to_top", _descriptor20, this);
    _initializerDefineProperty(this, "redirected_to_top", _descriptor21, this);
    _initializerDefineProperty(this, "treat_as_new_topic_start_date", _descriptor22, this);
    _initializerDefineProperty(this, "hasPMs", _descriptor23, this);
    _initializerDefineProperty(this, "hasStartedPMs", _descriptor24, this);
    _initializerDefineProperty(this, "hasUnreadPMs", _descriptor25, this);
    _initializerDefineProperty(this, "adminPath", _descriptor26, this);
    _initializerDefineProperty(this, "isBasic", _descriptor27, this);
    _initializerDefineProperty(this, "isRegular", _descriptor28, this);
    _initializerDefineProperty(this, "isLeader", _descriptor29, this);
    _initializerDefineProperty(this, "canManageTopic", _descriptor30, this);
    _initializerDefineProperty(this, "sidebarCategoryIds", _descriptor31, this);
    _initializerDefineProperty(this, "sidebarSections", _descriptor32, this);
    _initializerDefineProperty(this, "sidebarTagNames", _descriptor33, this);
    _initializerDefineProperty(this, "groupsWithMessages", _descriptor34, this);
    _initializerDefineProperty(this, "canPickThemeWithCustomHomepage", _descriptor35, this);
    _defineProperty(this, "numGroupsToDisplay", 2);
    _defineProperty(this, "statusManager", new UserStatusManager(this));
  }
  canBeDeleted(canBeDeleted, postCount) {
    const maxPostCount = this.siteSettings.delete_all_posts_max;
    return canBeDeleted && postCount <= maxPostCount;
  }
  stream() {
    return UserStream.create({
      user: this
    });
  }
  bookmarks() {
    return Bookmark.create({
      user: this
    });
  }
  postsStream() {
    return UserPostsStream.create({
      user: this
    });
  }
  userDraftsStream() {
    return UserDraftsStream.create({
      user: this
    });
  }
  get staff() {
    return this.admin || this.moderator;
  }

  // prevents staff property to be overridden
  set staff(value) {}
  destroySession() {
    return ajax(`/session/${this.username}`, {
      type: "DELETE"
    });
  }
  searchContext(username) {
    return {
      type: "user",
      id: username,
      user: this
    };
  }
  displayName(username, name) {
    if (this.siteSettings.enable_names && !isEmpty(name)) {
      return name;
    }
    return username;
  }
  profileBackgroundUrl(bgUrl) {
    if (isEmpty(bgUrl) || !this.siteSettings.allow_profile_backgrounds) {
      return htmlSafe("");
    }
    return htmlSafe("background-image: url(" + getURLWithCDN(bgUrl) + ")");
  }
  path() {
    // no need to observe, requires a hard refresh to update
    return userPath(this.username_lower);
  }
  userApiKeys() {
    const keys = this.user_api_keys;
    if (keys) {
      return keys.map(raw => {
        let obj = EmberObject.create(raw);
        obj.revoke = () => {
          this.revokeApiKey(obj);
        };
        obj.undoRevoke = () => {
          this.undoRevokeApiKey(obj);
        };
        return obj;
      });
    }
  }
  revokeApiKey(key) {
    return ajax("/user-api-key/revoke", {
      type: "POST",
      data: {
        id: key.get("id")
      }
    }).then(() => {
      key.set("revoked", true);
    });
  }
  undoRevokeApiKey(key) {
    return ajax("/user-api-key/undo-revoke", {
      type: "POST",
      data: {
        id: key.get("id")
      }
    }).then(() => {
      key.set("revoked", false);
    });
  }
  pmPath(topic) {
    const username = this.username_lower;
    const details = topic.details;
    const allowedUsers = details?.allowed_users;
    const groups = details?.allowed_groups;

    // directly targeted so go to inbox
    if (!groups || allowedUsers?.findBy("id", this.id)) {
      return userPath(`${username}/messages`);
    } else if (groups) {
      const firstAllowedGroup = groups.find(allowedGroup => this.groups.some(userGroup => userGroup.id === allowedGroup.id));
      if (firstAllowedGroup) {
        return userPath(`${username}/messages/group/${firstAllowedGroup.name}`);
      }
    }
  }
  mutedTopicsPath() {
    return defaultHomepage() === "latest" ? getURL("/?state=muted") : getURL("/latest?state=muted");
  }
  watchingTopicsPath() {
    return defaultHomepage() === "latest" ? getURL("/?state=watching") : getURL("/latest?state=watching");
  }
  trackingTopicsPath() {
    return defaultHomepage() === "latest" ? getURL("/?state=tracking") : getURL("/latest?state=tracking");
  }
  username_lower(username) {
    return username.toLowerCase();
  }
  trustLevel(trustLevel) {
    return Site.currentProp("trustLevels").findBy("id", parseInt(trustLevel, 10));
  }
  previousVisitAt(previous_visit_at) {
    return new Date(previous_visit_at);
  }
  suspended(suspendedTill) {
    return suspendedTill && moment(suspendedTill).isAfter();
  }
  suspendedForever(suspendedTill) {
    return isForever(suspendedTill);
  }
  silencedForever(silencedTill) {
    isForever(silencedTill);
  }
  suspendedTillDate(silencedTill) {
    return longDate(silencedTill);
  }
  silencedTillDate(silencedTill) {
    return longDate(silencedTill);
  }
  sidebarTags(sidebarTags) {
    if (!sidebarTags || sidebarTags.length === 0) {
      return [];
    }
    return sidebarTags.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }
  changeUsername(new_username) {
    return ajax(userPath(`${this.username_lower}/preferences/username`), {
      type: "PUT",
      data: {
        new_username
      }
    });
  }
  addEmail(email) {
    return ajax(userPath(`${this.username_lower}/preferences/email`), {
      type: "POST",
      data: {
        email
      }
    }).then(() => {
      if (!this.unconfirmed_emails) {
        this.set("unconfirmed_emails", []);
      }
      this.unconfirmed_emails.pushObject(email);
    });
  }
  changeEmail(email) {
    return ajax(userPath(`${this.username_lower}/preferences/email`), {
      type: "PUT",
      data: {
        email
      }
    }).then(() => {
      if (!this.unconfirmed_emails) {
        this.set("unconfirmed_emails", []);
      }
      this.unconfirmed_emails.pushObject(email);
    });
  }
  save(fields) {
    const data = this.getProperties(userFields.filter(uf => !fields || fields.includes(uf)));
    const filteredUserOptionFields = fields ? userOptionFields.filter(uo => fields.includes(uo)) : userOptionFields;
    filteredUserOptionFields.forEach(s => {
      data[s] = this.get(`user_option.${s}`);
    });
    const updatedState = {};
    ["muted", "regular", "watched", "tracked", "watched_first_post"].forEach(categoryNotificationLevel => {
      if (fields === undefined || fields.includes(`${categoryNotificationLevel}_category_ids`)) {
        const categories = this.get(`${camelize(categoryNotificationLevel)}Categories`);
        if (categories) {
          const ids = categories.map(c => c.get("id"));
          updatedState[`${categoryNotificationLevel}_category_ids`] = ids;
          // HACK: Empty arrays are not sent in the request, we use [-1],
          // an invalid category ID, that will be ignored by the server.
          data[`${categoryNotificationLevel}_category_ids`] = ids.length === 0 ? [-1] : ids;
        }
      }
    });
    ["muted_tags", "tracked_tags", "watched_tags", "watching_first_post_tags"].forEach(prop => {
      if (fields === undefined || fields.includes(prop)) {
        data[prop] = this.get(prop) ? this.get(prop).join(",") : "";
      }
    });
    ["sidebar_category_ids", "sidebar_tag_names"].forEach(prop => {
      if (data[prop]?.length === 0) {
        data[prop] = null;
      }
    });

    // TODO: We can remove this when migrated fully to rest model.
    this.set("isSaving", true);
    return ajax(userPath(`${this.username_lower}.json`), {
      data,
      type: "PUT"
    }).then(result => {
      this.setProperties(updatedState);
      this.setProperties(getProperties(result.user, "bio_excerpt"));
      return result;
    }).finally(() => {
      this.set("isSaving", false);
    });
  }
  setPrimaryEmail(email) {
    return ajax(userPath(`${this.username}/preferences/primary-email.json`), {
      type: "PUT",
      data: {
        email
      }
    }).then(() => {
      this.secondary_emails.removeObject(email);
      this.secondary_emails.pushObject(this.email);
      this.set("email", email);
    });
  }
  destroyEmail(email) {
    return ajax(userPath(`${this.username}/preferences/email.json`), {
      type: "DELETE",
      data: {
        email
      }
    }).then(() => {
      if (this.unconfirmed_emails.includes(email)) {
        this.unconfirmed_emails.removeObject(email);
      } else {
        this.secondary_emails.removeObject(email);
      }
    });
  }
  changePassword() {
    return ajax("/session/forgot_password", {
      dataType: "json",
      data: {
        login: this.email || this.username
      },
      type: "POST"
    });
  }
  loadSecondFactorCodes() {
    return ajax("/u/second_factors.json", {
      type: "POST"
    });
  }
  requestSecurityKeyChallenge() {
    return ajax("/u/create_second_factor_security_key.json", {
      type: "POST"
    });
  }
  registerSecurityKey(credential) {
    return ajax("/u/register_second_factor_security_key.json", {
      data: credential,
      type: "POST"
    });
  }
  trustedSession() {
    return ajax("/u/trusted-session.json");
  }
  createPasskey() {
    return ajax("/u/create_passkey.json", {
      type: "POST"
    });
  }
  registerPasskey(credential) {
    return ajax("/u/register_passkey.json", {
      data: credential,
      type: "POST"
    });
  }
  deletePasskey(id) {
    return ajax(`/u/delete_passkey/${id}`, {
      type: "DELETE"
    });
  }
  createSecondFactorTotp() {
    return ajax("/u/create_second_factor_totp.json", {
      type: "POST"
    });
  }
  enableSecondFactorTotp(authToken, name) {
    return ajax("/u/enable_second_factor_totp.json", {
      data: {
        second_factor_token: authToken,
        name
      },
      type: "POST"
    });
  }
  disableAllSecondFactors() {
    return ajax("/u/disable_second_factor.json", {
      type: "PUT"
    });
  }
  updateSecondFactor(id, name, disable, targetMethod) {
    return ajax("/u/second_factor.json", {
      data: {
        second_factor_target: targetMethod,
        name,
        disable,
        id
      },
      type: "PUT"
    });
  }
  updateSecurityKey(id, name, disable) {
    return ajax("/u/security_key.json", {
      data: {
        name,
        disable,
        id
      },
      type: "PUT"
    });
  }
  toggleSecondFactor(authToken, authMethod, targetMethod, enable) {
    return ajax("/u/second_factor.json", {
      data: {
        second_factor_token: authToken,
        second_factor_method: authMethod,
        second_factor_target: targetMethod,
        enable
      },
      type: "PUT"
    });
  }
  generateSecondFactorCodes() {
    return ajax("/u/second_factors_backup.json", {
      type: "PUT"
    });
  }
  revokeAssociatedAccount(providerName) {
    return ajax(userPath(`${this.username}/preferences/revoke-account`), {
      data: {
        provider_name: providerName
      },
      type: "POST"
    });
  }
  async loadUserAction(id) {
    const result = await ajax(`/user_actions/${id}.json`);
    if (!result?.user_action) {
      return;
    }
    const ua = result.user_action;
    if ((this.get("stream.filter") || ua.action_type) !== ua.action_type) {
      return;
    }
    if (!this.get("stream.filter") && !this.inAllStream(ua)) {
      return;
    }
    ua.title = emojiUnescape(escapeExpression(ua.title));
    const action = UserAction.collapseStream([UserAction.create(ua)]);
    this.stream.set("itemsLoaded", this.stream.get("itemsLoaded") + 1);
    this.stream.get("content").insertAt(0, action[0]);
  }
  inAllStream(ua) {
    return ua.action_type === UserAction.TYPES.posts || ua.action_type === UserAction.TYPES.topics;
  }
  filteredGroups() {
    const groups = this.groups || [];
    return groups.filter(group => {
      return !group.automatic || group.name === "moderators";
    });
  }
  displayGroups(filteredGroups, numGroupsToDisplay) {
    const groups = filteredGroups.slice(0, numGroupsToDisplay);
    return groups.length === 0 ? null : groups;
  }

  // The user's stat count, excluding PMs.
  statsCountNonPM() {
    if (isEmpty(this.statsExcludingPms)) {
      return 0;
    }
    let count = 0;
    this.statsExcludingPms.forEach(val => {
      if (this.inAllStream(val)) {
        count += val.count;
      }
    });
    return count;
  }

  // The user's stats, excluding PMs.
  statsExcludingPms() {
    if (isEmpty(this.stats)) {
      return [];
    }
    return this.stats.rejectBy("isPM");
  }
  findDetails(options) {
    const user = this;
    return PreloadStore.getAndRemove(`user_${user.get("username")}`, () => {
      if (options && options.existingRequest) {
        // Existing ajax request has been passed, use it
        return options.existingRequest;
      }
      const useCardRoute = options && options.forCard;
      if (options) {
        delete options.forCard;
      }
      const path = useCardRoute ? `${user.get("username")}/card.json` : `${user.get("username")}.json`;
      return ajax(userPath(path), {
        data: options
      });
    }).then(json => {
      if (!isEmpty(json.user.stats)) {
        json.user.stats = User.groupStats(json.user.stats.map(s => {
          if (s.count) {
            s.count = parseInt(s.count, 10);
          }
          return UserActionStat.create(s);
        }));
      }
      if (!isEmpty(json.user.groups) && !isEmpty(json.user.group_users)) {
        const groups = [];
        for (let i = 0; i < json.user.groups.length; i++) {
          const group = Group.create(json.user.groups[i]);
          group.group_user = json.user.group_users[i];
          groups.push(group);
        }
        json.user.groups = groups;
      }
      if (json.user.invited_by) {
        json.user.invited_by = User.create(json.user.invited_by);
      }
      if (!isEmpty(json.user.featured_user_badge_ids)) {
        const userBadgesMap = {};
        UserBadge.createFromJson(json).forEach(userBadge => {
          userBadgesMap[userBadge.get("id")] = userBadge;
        });
        json.user.featured_user_badges = json.user.featured_user_badge_ids.map(id => userBadgesMap[id]);
      }
      if (json.user.card_badge) {
        json.user.card_badge = Badge.create(json.user.card_badge);
      }
      user.setProperties(json.user);
      return user;
    });
  }
  findStaffInfo() {
    if (!User.currentProp("staff")) {
      return Promise.resolve(null);
    }
    return ajax(userPath(`${this.username_lower}/staff-info.json`)).then(info => {
      this.setProperties(info);
    });
  }
  pickAvatar(upload_id, type) {
    return ajax(userPath(`${this.username_lower}/preferences/avatar/pick`), {
      type: "PUT",
      data: {
        upload_id,
        type
      }
    });
  }
  selectAvatar(avatarUrl) {
    return ajax(userPath(`${this.username_lower}/preferences/avatar/select`), {
      type: "PUT",
      data: {
        url: avatarUrl
      }
    });
  }
  isAllowedToUploadAFile(type) {
    const settingName = type === "image" ? "embedded_media" : "attachments";
    return this.staff || this.trust_level > 0 || this.siteSettings[`newuser_max_${settingName}`] > 0;
  }
  createInvite(email, group_ids, custom_message) {
    return ajax("/invites", {
      type: "POST",
      data: {
        email,
        group_ids,
        custom_message
      }
    });
  }
  generateInviteLink(email, group_ids, topic_id) {
    return ajax("/invites", {
      type: "POST",
      data: {
        email,
        skip_email: true,
        group_ids,
        topic_id
      }
    });
  }
  get mutedCategories() {
    if (this.site.lazy_load_categories && this.muted_category_ids && !Category.hasAsyncFoundAll(this.muted_category_ids)) {
      Category.asyncFindByIds(this.muted_category_ids).then(() => this.notifyPropertyChange("muted_category_ids"));
    }
    return Category.findByIds(this.get("muted_category_ids"));
  }
  set mutedCategories(categories) {
    this.set("muted_category_ids", categories.map(c => c.id));
  }
  get regularCategories() {
    if (this.site.lazy_load_categories && this.regular_category_ids && !Category.hasAsyncFoundAll(this.regular_category_ids)) {
      Category.asyncFindByIds(this.regular_category_ids).then(() => this.notifyPropertyChange("regular_category_ids"));
    }
    return Category.findByIds(this.get("regular_category_ids"));
  }
  set regularCategories(categories) {
    this.set("regular_category_ids", categories.map(c => c.id));
  }
  get trackedCategories() {
    if (this.site.lazy_load_categories && this.tracked_category_ids && !Category.hasAsyncFoundAll(this.tracked_category_ids)) {
      Category.asyncFindByIds(this.tracked_category_ids).then(() => this.notifyPropertyChange("tracked_category_ids"));
    }
    return Category.findByIds(this.get("tracked_category_ids"));
  }
  set trackedCategories(categories) {
    this.set("tracked_category_ids", categories.map(c => c.id));
  }
  get watchedCategories() {
    if (this.site.lazy_load_categories && this.watched_category_ids && !Category.hasAsyncFoundAll(this.watched_category_ids)) {
      Category.asyncFindByIds(this.watched_category_ids).then(() => this.notifyPropertyChange("watched_category_ids"));
    }
    return Category.findByIds(this.get("watched_category_ids"));
  }
  set watchedCategories(categories) {
    this.set("watched_category_ids", categories.map(c => c.id));
  }
  get watchedFirstPostCategories() {
    if (this.site.lazy_load_categories && this.watched_first_post_category_ids && !Category.hasAsyncFoundAll(this.watched_first_post_category_ids)) {
      Category.asyncFindByIds(this.watched_first_post_category_ids).then(() => this.notifyPropertyChange("watched_first_post_category_ids"));
    }
    return Category.findByIds(this.get("watched_first_post_category_ids"));
  }
  set watchedFirstPostCategories(categories) {
    this.set("watched_first_post_category_ids", categories.map(c => c.id));
  }
  canDeleteAccount(canDeleteAccount) {
    return !this.siteSettings.enable_discourse_connect && canDeleteAccount;
  }
  get sidebarLinkToFilteredList() {
    return this.get("user_option.sidebar_link_to_filtered_list");
  }
  get sidebarShowCountOfNewItems() {
    return this.get("user_option.sidebar_show_count_of_new_items");
  }
  delete() {
    if (this.can_delete_account) {
      return ajax(userPath(this.username + ".json"), {
        type: "DELETE",
        data: {
          context: window.location.pathname
        }
      });
    } else {
      return Promise.reject(I18n.t("user.delete_yourself_not_allowed"));
    }
  }
  updateNotificationLevel(_ref) {
    let {
      level,
      expiringAt = null,
      actingUser = null
    } = _ref;
    actingUser ||= User.current();
    return ajax(`${userPath(this.username)}/notification_level.json`, {
      type: "PUT",
      data: {
        notification_level: level,
        expiring_at: expiringAt,
        acting_user_id: actingUser.id
      }
    }).then(() => {
      if (!actingUser.ignored_users) {
        actingUser.ignored_users = [];
      }
      if (level === "normal" || level === "mute") {
        actingUser.ignored_users.removeObject(this.username);
      } else if (level === "ignore") {
        actingUser.ignored_users.addObject(this.username);
      }
    });
  }
  dismissBanner(bannerKey) {
    this.set("dismissed_banner_key", bannerKey);
    ajax(userPath(this.username + ".json"), {
      type: "PUT",
      data: {
        dismissed_banner_key: bannerKey
      }
    });
  }
  checkEmail() {
    return ajax(userPath(`${this.username_lower}/emails.json`), {
      data: {
        context: window.location.pathname
      }
    }).then(result => {
      if (result) {
        this.setProperties({
          email: result.email,
          secondary_emails: result.secondary_emails,
          unconfirmed_emails: result.unconfirmed_emails,
          associated_accounts: result.associated_accounts
        });
      }
    });
  }
  summary() {
    const store = getOwnerWithFallback(this).lookup("service:store");
    return ajax(userPath(`${this.username_lower}/summary.json`)).then(json => {
      const summary = json.user_summary;
      const topicMap = {};
      const badgeMap = {};
      json.topics.forEach(t => topicMap[t.id] = store.createRecord("topic", t));
      Badge.createFromJson(json).forEach(b => badgeMap[b.id] = b);
      summary.topics = summary.topic_ids.map(id => topicMap[id]);
      summary.replies.forEach(r => {
        r.topic = topicMap[r.topic_id];
        r.url = r.topic.urlForPostNumber(r.post_number);
        r.createdAt = new Date(r.created_at);
      });
      summary.links.forEach(l => {
        l.topic = topicMap[l.topic_id];
        l.post_url = l.topic.urlForPostNumber(l.post_number);
      });
      if (summary.badges) {
        summary.badges = summary.badges.map(ub => {
          const badge = badgeMap[ub.badge_id];
          badge.count = ub.count;
          return badge;
        });
      }
      if (summary.top_categories) {
        summary.top_categories.forEach(c => {
          if (c.parent_category_id) {
            c.parentCategory = Category.findById(c.parent_category_id);
          }
        });
      }
      return summary;
    });
  }
  canManageGroup(group) {
    return group.get("automatic") ? false : group.get("can_admin_group") || group.get("is_group_owner");
  }
  availableTitles() {
    const titles = [];
    (this.groups || []).forEach(group => {
      if (get(group, "title")) {
        titles.push(get(group, "title"));
      }
    });
    (this.badges || []).forEach(badge => {
      if (get(badge, "allow_title")) {
        titles.push(get(badge, "name"));
      }
    });
    return titles.uniq().sort().map(title => {
      return {
        name: escapeExpression(title),
        id: title
      };
    });
  }
  availableFlairs() {
    const flairs = [];
    if (this.groups) {
      this.groups.forEach(group => {
        if (group.flair_url) {
          flairs.push({
            id: group.id,
            name: group.name,
            url: group.flair_url,
            bgColor: group.flair_bg_color,
            color: group.flair_color
          });
        }
      });
    }
    return flairs;
  }
  currentTextSize(serverSeq, serverSize) {
    if (cookie(TEXT_SIZE_COOKIE_NAME)) {
      const [cookieSize, cookieSeq] = cookie(TEXT_SIZE_COOKIE_NAME).split("|");
      if (cookieSeq >= serverSeq) {
        return cookieSize;
      }
    }
    return serverSize;
  }
  updateTextSizeCookie(newSize) {
    if (newSize) {
      const seq = this.get("user_option.text_size_seq");
      cookie(TEXT_SIZE_COOKIE_NAME, `${newSize}|${seq}`, {
        path: "/",
        expires: COOKIE_EXPIRY_DAYS
      });
    } else {
      removeCookie(TEXT_SIZE_COOKIE_NAME, {
        path: "/"
      });
    }
  }
  enforcedSecondFactor(secondFactorEnabled, staff) {
    const enforce = this.siteSettings.enforce_second_factor;
    return !secondFactorEnabled && (enforce === "all" || enforce === "staff" && staff);
  }
  resolvedTimezone() {
    deprecated("user.resolvedTimezone() has been deprecated. Use user.user_option.timezone instead", {
      id: "discourse.user.resolved-timezone",
      since: "2.9.0.beta12",
      dropFrom: "3.0.0.beta1"
    });
    return this.user_option.timezone;
  }
  calculateMutedIds(notificationLevel, id, type) {
    const muted_ids = this.get(type);
    if (notificationLevel === NotificationLevels.MUTED) {
      return muted_ids.concat(id).uniq();
    } else {
      return muted_ids.filter(existing_id => existing_id !== id);
    }
  }
  setPrimaryGroup(primaryGroupId) {
    return ajax(`/admin/users/${this.id}/primary_group`, {
      type: "PUT",
      data: {
        primary_group_id: primaryGroupId
      }
    });
  }
  enterDoNotDisturbFor(duration) {
    return ajax({
      url: "/do-not-disturb.json",
      type: "POST",
      data: {
        duration
      }
    }).then(response => {
      return this.updateDoNotDisturbStatus(response.ends_at);
    });
  }
  leaveDoNotDisturb() {
    return ajax({
      url: "/do-not-disturb.json",
      type: "DELETE"
    }).then(() => {
      this.updateDoNotDisturbStatus(null);
    });
  }
  updateDoNotDisturbStatus(ends_at) {
    this.set("do_not_disturb_until", ends_at);
    this.appEvents.trigger("do-not-disturb:changed", this.do_not_disturb_until);
  }
  updateDraftProperties(properties) {
    this.setProperties(properties);
    this.appEvents.trigger("user-drafts:changed");
  }
  updateReviewableCount(count) {
    this.set("reviewable_count", count);
    this.appEvents.trigger("user-reviewable-count:changed", count);
  }
  isInDoNotDisturb() {
    return this.do_not_disturb_until && new Date(this.do_not_disturb_until) >= new Date();
  }
  trackedTags(trackedTags, watchedTags, watchingFirstPostTags) {
    return [...trackedTags, ...watchedTags, ...watchingFirstPostTags];
  }
}, (_descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "userTips", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "do_not_disturb_until", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "status", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "mailing_list_mode", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "external_links_in_new_tab", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "enable_quoting", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "dynamic_favicon", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "automatically_unpin_topics", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "likes_notifications_disabled", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "hide_profile_and_presence", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "title_count_mode", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "enable_defer", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "timezone", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "skip_new_user_tips", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "default_calendar", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "bookmark_auto_delete_preference", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "seen_popups", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "should_be_redirected_to_top", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, "redirected_to_top", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class2.prototype, "treat_as_new_topic_start_date", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class2.prototype, "hasPMs", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class2.prototype, "hasStartedPMs", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class2.prototype, "hasUnreadPMs", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class2.prototype, "adminPath", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class2.prototype, "isBasic", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class2.prototype, "isRegular", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class2.prototype, "isLeader", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class2.prototype, "canManageTopic", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class2.prototype, "sidebarCategoryIds", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class2.prototype, "sidebarSections", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class2.prototype, "sidebarTagNames", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class2.prototype, "groupsWithMessages", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class2.prototype, "canPickThemeWithCustomHomepage", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "canBeDeleted", [_dec31], Object.getOwnPropertyDescriptor(_class2.prototype, "canBeDeleted"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "stream", [_dec32], Object.getOwnPropertyDescriptor(_class2.prototype, "stream"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "bookmarks", [_dec33], Object.getOwnPropertyDescriptor(_class2.prototype, "bookmarks"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "postsStream", [_dec34], Object.getOwnPropertyDescriptor(_class2.prototype, "postsStream"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userDraftsStream", [_dec35], Object.getOwnPropertyDescriptor(_class2.prototype, "userDraftsStream"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "staff", [_dec36], Object.getOwnPropertyDescriptor(_class2.prototype, "staff"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "searchContext", [_dec37], Object.getOwnPropertyDescriptor(_class2.prototype, "searchContext"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "displayName", [_dec38], Object.getOwnPropertyDescriptor(_class2.prototype, "displayName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "profileBackgroundUrl", [_dec39], Object.getOwnPropertyDescriptor(_class2.prototype, "profileBackgroundUrl"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "path", [_dec40], Object.getOwnPropertyDescriptor(_class2.prototype, "path"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "userApiKeys", [_dec41], Object.getOwnPropertyDescriptor(_class2.prototype, "userApiKeys"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mutedTopicsPath", [_dec42], Object.getOwnPropertyDescriptor(_class2.prototype, "mutedTopicsPath"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "watchingTopicsPath", [_dec43], Object.getOwnPropertyDescriptor(_class2.prototype, "watchingTopicsPath"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "trackingTopicsPath", [_dec44], Object.getOwnPropertyDescriptor(_class2.prototype, "trackingTopicsPath"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "username_lower", [_dec45], Object.getOwnPropertyDescriptor(_class2.prototype, "username_lower"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "trustLevel", [_dec46], Object.getOwnPropertyDescriptor(_class2.prototype, "trustLevel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "previousVisitAt", [_dec47], Object.getOwnPropertyDescriptor(_class2.prototype, "previousVisitAt"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "suspended", [_dec48], Object.getOwnPropertyDescriptor(_class2.prototype, "suspended"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "suspendedForever", [_dec49], Object.getOwnPropertyDescriptor(_class2.prototype, "suspendedForever"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "silencedForever", [_dec50], Object.getOwnPropertyDescriptor(_class2.prototype, "silencedForever"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "suspendedTillDate", [_dec51], Object.getOwnPropertyDescriptor(_class2.prototype, "suspendedTillDate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "silencedTillDate", [_dec52], Object.getOwnPropertyDescriptor(_class2.prototype, "silencedTillDate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sidebarTags", [_dec53], Object.getOwnPropertyDescriptor(_class2.prototype, "sidebarTags"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filteredGroups", [_dec54], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredGroups"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "displayGroups", [_dec55], Object.getOwnPropertyDescriptor(_class2.prototype, "displayGroups"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "statsCountNonPM", [_dec56], Object.getOwnPropertyDescriptor(_class2.prototype, "statsCountNonPM"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "statsExcludingPms", [_dec57], Object.getOwnPropertyDescriptor(_class2.prototype, "statsExcludingPms"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "mutedCategories", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class2.prototype, "mutedCategories"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "regularCategories", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class2.prototype, "regularCategories"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "trackedCategories", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class2.prototype, "trackedCategories"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "watchedCategories", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class2.prototype, "watchedCategories"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "watchedFirstPostCategories", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class2.prototype, "watchedFirstPostCategories"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canDeleteAccount", [_dec58], Object.getOwnPropertyDescriptor(_class2.prototype, "canDeleteAccount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sidebarLinkToFilteredList", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class2.prototype, "sidebarLinkToFilteredList"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sidebarShowCountOfNewItems", [dependentKeyCompat], Object.getOwnPropertyDescriptor(_class2.prototype, "sidebarShowCountOfNewItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "availableTitles", [_dec59], Object.getOwnPropertyDescriptor(_class2.prototype, "availableTitles"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "availableFlairs", [_dec60], Object.getOwnPropertyDescriptor(_class2.prototype, "availableFlairs"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTextSize", [_dec61], Object.getOwnPropertyDescriptor(_class2.prototype, "currentTextSize"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enforcedSecondFactor", [_dec62], Object.getOwnPropertyDescriptor(_class2.prototype, "enforcedSecondFactor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "trackedTags", [_dec63], Object.getOwnPropertyDescriptor(_class2.prototype, "trackedTags"), _class2.prototype)), _class2));
export { User as default };
User.reopenClass(Singleton, {
  // Find a `User` for a given username.
  findByUsername(username, options) {
    const user = User.create({
      username
    });
    return user.findDetails(options);
  },
  // TODO: Use app.register and junk Singleton
  createCurrent() {
    const userJson = PreloadStore.get("currentUser");
    if (userJson) {
      userJson.isCurrent = true;
      if (userJson.primary_group_id) {
        const primaryGroup = userJson.groups.find(group => group.id === userJson.primary_group_id);
        if (primaryGroup) {
          userJson.primary_group_name = primaryGroup.name;
        }
      }
      if (!userJson.user_option.timezone) {
        userJson.user_option.timezone = moment.tz.guess();
        this._saveTimezone(userJson);
      }
      const store = getOwnerWithFallback(this).lookup("service:store");
      const currentUser = store.createRecord("user", userJson);
      currentUser.statusManager.trackStatus();
      return currentUser;
    }
    return null;
  },
  checkUsername(username, email, for_user_id) {
    return ajax(userPath("check_username"), {
      data: {
        username,
        email,
        for_user_id
      }
    });
  },
  checkEmail(email) {
    return ajax(userPath("check_email"), {
      data: {
        email
      }
    });
  },
  loadRecentSearches() {
    return ajax(`/u/recent-searches`);
  },
  resetRecentSearches() {
    return ajax(`/u/recent-searches`, {
      type: "DELETE"
    });
  },
  groupStats(stats) {
    const responses = UserActionStat.create({
      count: 0,
      action_type: UserAction.TYPES.replies
    });
    stats.filterBy("isResponse").forEach(stat => {
      responses.set("count", responses.get("count") + stat.get("count"));
    });
    const result = A();
    result.pushObjects(stats.rejectBy("isResponse"));
    let insertAt = 0;
    result.forEach((item, index) => {
      if (item.action_type === UserAction.TYPES.topics || item.action_type === UserAction.TYPES.posts) {
        insertAt = index + 1;
      }
    });
    if (responses.count > 0) {
      result.insertAt(insertAt, responses);
    }
    return result;
  },
  createAccount(attrs) {
    let data = {
      name: attrs.accountName,
      email: attrs.accountEmail,
      password: attrs.accountPassword,
      username: attrs.accountUsername,
      password_confirmation: attrs.accountPasswordConfirm,
      challenge: attrs.accountChallenge,
      user_fields: attrs.userFields,
      timezone: moment.tz.guess()
    };
    if (attrs.inviteCode) {
      data.invite_code = attrs.inviteCode;
    }
    return ajax(userPath(), {
      data,
      type: "POST"
    });
  },
  _saveTimezone(user) {
    ajax(userPath(user.username + ".json"), {
      type: "PUT",
      dataType: "json",
      data: {
        timezone: user.user_option.timezone
      }
    });
  },
  create(args) {
    args = args || {};
    this.deleteStatusTrackingFields(args);
    return this._super(args);
  },
  deleteStatusTrackingFields(args) {
    // every user instance has to have it's own tracking fields
    // when creating a new user model
    // its _subscribersCount and _clearStatusTimerId fields
    // should be equal to 0 and null
    // here we makes sure that even if these fields
    // will be passed in args they won't be set anyway
    //
    // this is something that could be implemented by making these fields private,
    // but EmberObject doesn't support private fields
    if (args.hasOwnProperty("_subscribersCount")) {
      delete args._subscribersCount;
    }
    if (args.hasOwnProperty("_clearStatusTimerId")) {
      delete args._clearStatusTimerId;
    }
  }
});

// user status tracking
let UserStatusManager = (_class = class UserStatusManager {
  constructor(user) {
    _initializerDefineProperty(this, "appEvents", _descriptor, this);
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "_subscribersCount", 0);
    _defineProperty(this, "_clearStatusTimerId", null);
    this.user = user;
    setOwner(this, getOwner(user));
  }

  // always call stopTrackingStatus() when done with a user
  trackStatus() {
    if (!this.user.id && !isTesting()) {
      // eslint-disable-next-line no-console
      console.warn("It's impossible to track user status on a user model that doesn't have id. This user model won't be receiving live user status updates.");
    }
    if (this._subscribersCount === 0) {
      this.user.addObserver("status", this, "_statusChanged");
      this.appEvents.on("user-status:changed", this, this._updateStatus);
      if (this.user.status?.ends_at) {
        this._scheduleStatusClearing(this.user.status.ends_at);
      }
    }
    this._subscribersCount++;
  }
  stopTrackingStatus() {
    if (this._subscribersCount === 0) {
      return;
    }
    if (this._subscribersCount === 1) {
      // the last subscriber is unsubscribing
      this.user.removeObserver("status", this, "_statusChanged");
      this.appEvents.off("user-status:changed", this, this._updateStatus);
      this._unscheduleStatusClearing();
    }
    this._subscribersCount--;
  }
  isTrackingStatus() {
    return this._subscribersCount > 0;
  }
  _statusChanged() {
    this.user.trigger("status-changed");
    const status = this.user.status;
    if (status && status.ends_at) {
      this._scheduleStatusClearing(status.ends_at);
    } else {
      this._unscheduleStatusClearing();
    }
  }
  _scheduleStatusClearing(endsAt) {
    if (isTesting()) {
      return;
    }
    if (this._clearStatusTimerId) {
      this._unscheduleStatusClearing();
    }
    const utcNow = moment.utc();
    const remaining = moment.utc(endsAt).diff(utcNow, "milliseconds");
    this._clearStatusTimerId = discourseLater(this, "_autoClearStatus", remaining);
  }
  _unscheduleStatusClearing() {
    cancel(this._clearStatusTimerId);
    this._clearStatusTimerId = null;
  }
  _autoClearStatus() {
    this.user.set("status", null);
  }
  _updateStatus(statuses) {
    if (statuses.hasOwnProperty(this.user.id)) {
      this.user.set("status", statuses[this.user.id]);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
if (typeof Discourse !== "undefined") {
  let warned = false;
  // eslint-disable-next-line no-undef
  Object.defineProperty(Discourse, "User", {
    get() {
      if (!warned) {
        deprecated("Import the User class instead of using Discourse.User", {
          since: "2.4.0",
          id: "discourse.globals.user"
        });
        warned = true;
      }
      return User;
    }
  });
}